import React, { useEffect, useRef, useState } from 'react'
import {
  useHistory,
  useLocation,
  withRouter,
  RouteComponentProps
} from 'react-router-dom'
// import { toast, ToastOptions } from 'react-toastify'

// import {
//   ResumoDeDocumentosDeSaidaMapper,
//   selecaoDeDocumentosParaEnvio,
//   UploadDocumentos,
//   useRelacaoDeDocumentos
// } from 'src/compartilhados'
// import { RelacaoDocumentosCursoCertificacao } from 'src/compartilhados/modulos/gestao-de-documentos/data/relacao-de-documentos-curso-certificacao.data'
import {
  FormUnform,
  Botao,
  Breadcrumb,
  Cabecalho,
  focarPrimeiroCampoOuEditorComErro,
  IconeBack,
  Link,
  ModalRef,
  SelectOpcao,
  SubTitulo,
  InputUnform,
  NumeroInputUnform,
  Spacer,
  Modal,
  AutenticacaoContainer,
  Visao
  // ErroLayoutContainer
} from 'src/componentes'
import { SelectUnform } from 'src/componentes/unform/select'
import { CursoCertificacaoPayload } from 'src/dto'
import { ContainerDadosGrande } from 'src/paginas/professor/meu-cadastro/styles'
import { RotasCursoCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import {
  ModalidadeCurso,
  ModalidadeCursoCertificacao,
  DivisaoCursoCertificacao,
  ModuloCursoCertificacao,
  DisciplinaCursoCertificacao
} from 'src/tipos'
import { ModoPaginaCadastro } from 'src/tipos/genericos'

import { ContainerCertificacao } from '../../styles'
import {
  DesvincularDisciplinaModulo,
  ListaModuloDisciplina,
  ModalEditarModulo,
  ModalExcluirDisciplina,
  ModalIncluirDisciplina,
  ModalIncluirModulo,
  ModalVincularDisciplinaModulo,
  OPCOES_AREA,
  OPCOES_TITULACAO_COORDENADOR
} from './componentes'
// import DocumentosCursoCertificacao, {
//   DocumentosCursoCertificacaoHandles
// } from './componentes/documentos/documentos-curso-certificacao'
import { ModalEditarModuloCertificacaoRef } from './componentes/modal-editar-modulo/tipos'
import { ModalIncluirDisciplinaCertificacaoRef } from './componentes/modal-incluir-disciplina/tipos'
import { ModalIncluirModuloCertificacaoRef } from './componentes/modal-incluir-modulo/tipos'
import { ModalVincularDisciplinaModuloRef } from './componentes/modal-vincular-disciplina-modulo/tipos'
import { createSchema } from './schema'
import {
  Container,
  ContainerMain,
  ContainerDadosMedio,
  Conteudo,
  ContainerDados,
  ContainerAcoes,
  FormContainer,
  ContainerLink,
  SecaoPrimaria
} from './styles'
import { DisciplinaCertificacaoVinculada } from './tipos'

export interface PaginaCursosCertificacaoProps
  extends RouteComponentProps<{
    id?: string
    modalidade?: ModalidadeCursoCertificacao
  }> {
  modo?: ModoPaginaCadastro
}

const PaginaCursos: React.FC<PaginaCursosCertificacaoProps> = ({
  match,
  modo
}) => {
  const { visao } = AutenticacaoContainer.useContainer()
  const modalRef = useRef<ModalRef>(null)
  // const documentosRef = useRef<DocumentosCursoCertificacaoHandles>(null)
  const modalIncluirModuloRef = useRef<ModalIncluirModuloCertificacaoRef>(null)
  // const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos(
  //   RelacaoDocumentosCursoCertificacao
  // )
  const modalIncluirDisciplinaRef = useRef<ModalIncluirDisciplinaCertificacaoRef>(
    null
  )
  const modalEditarModuloRef = useRef<ModalEditarModuloCertificacaoRef>(null)
  const modalDisciplinaModuloRef = useRef<ModalRef>(null)
  const modalDesvincularDisciplinaref = useRef<ModalVincularDisciplinaModuloRef>(
    null
  )
  const modalExcluirDisciplinaref = useRef<ModalIncluirDisciplinaCertificacaoRef>(
    null
  )
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const usuarioId = usuarioObj.id
  const [curso, definirCurso] = useState<CursoCertificacaoPayload | undefined>(
    undefined
  )
  const [modulosCurso, definirModulosCurso] = useState<
    ModuloCursoCertificacao[]
  >([])
  // const [idCurso, setIdCurso] = useState<string>()
  const [disciplinasCurso, definirDisciplinasCurso] = useState<
    DisciplinaCursoCertificacao[]
  >([])
  const [indexModulo, defineIndexModulo] = useState(null)
  const [titulo] = useState(
    `${modo === ModoPaginaCadastro.Inclusao ? 'Inclusão' : 'Edição'} de Curso`
  )
  const history = useHistory()
  const [pronto, definirPronto] = useState(true)
  const { state } = useLocation<{ modalidade?: ModalidadeCurso }>()
  const [modalidadeCurso, definirModalidade] = useState<string>(
    state?.modalidade ?? match.params.modalidade
  )
  const [divisaoCurso, definirDivisao] = useState<string>(undefined)
  const [carregando, definirCarregando] = useState(false)
  // const [dispararUpload, setDispararUpload] = useState(false)

  // const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
  // const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
  // const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'

  // const toastOptions = { type: 'error' } as ToastOptions

  enum Navegacoes {
    DadosCurso = 'dados-curso',
    InformacoesFinanceiras = 'informacoes-financeiras',
    InformacoesIniciasCurso = 'informacoes-iniciais-curso',
    InformacoesCurso = 'informacoes-curso',
    Disciplinas = 'disciplinas',
    Avaliacoes = 'avaliacoes',
    GradeCurricular = 'grade-curricular',
    VersoCertificado = 'verso-certificado',
    PesquisaSatisfacao = 'pesquisa-satisfacao'
  }

  // useEffect(() => {
  //   if (modo === ModoPaginaCadastro.Edicao) {
  //     setIdCurso(match.params.id)
  //   }
  // }, [])

  const carregarCurso = async () => {
    try {
      const cursoParaEdicao = await Api.RequisitarCursoCertificacao(
        match.params.id
      )
      const cursoCertificacao = cursoParaEdicao as CursoCertificacaoPayload
      definirCurso(cursoCertificacao)
      if (cursoCertificacao.divisao === DivisaoCursoCertificacao.Modulo) {
        definirModulosCurso(
          cursoCertificacao.modulosCertificacao as ModuloCursoCertificacao[]
        )
        definirDisciplinasCurso([])
      } else {
        definirDisciplinasCurso(
          cursoCertificacao.disciplinasCertificacao as DisciplinaCursoCertificacao[]
        )
        definirModulosCurso([])
      }
    } catch (error) {
    } finally {
      definirPronto(true)
    }
  }

  const focarNoPrimeiroErro = (idContexto?: string): void => {
    setTimeout(() => {
      const selecaoDoEditor = '#informacoes-container > #erro-informacoes'
      return focarPrimeiroCampoOuEditorComErro(selecaoDoEditor)(idContexto)
    }, 0)
  }

  // const uploadDeCriacao = async (
  //   cursoId: string,
  //   documentos: UploadDocumentos[]
  // ): Promise<void> => {
  //   try {
  //     const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
  //     const resposta = await Api.EnviarDocumentosCursoCertificacao(
  //       cursoId,
  //       formulario
  //     )

  //     if (!resposta) {
  //       toast(erroAoEnviarDocumentos, toastOptions)
  //     }
  //   } catch (erro) {
  //     toast(erroAoEnviarDocumentos, toastOptions)
  //   }
  // }

  // const uploadDeEdicao = async (
  //   cursoId: string,
  //   documentos: UploadDocumentos[]
  // ): Promise<void> => {
  //   try {
  //     const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
  //     const resposta = await Api.EditarDocumentosCursoCertificacao(
  //       cursoId,
  //       formulario
  //     )

  //     if (resposta) {
  //       const documentosAprovados = documentos.filter(
  //         x => x.motivoAlteracaoAprovado
  //       )

  //       if (documentosAprovados?.length > 0) {
  //         try {
  //           await Api.AlteracaoAprovado(cursoId, documentosAprovados)
  //         } catch {
  //           toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
  //         }
  //       }
  //     } else {
  //       toast(erroAoAtualizarDocumentos, toastOptions)
  //     }
  //   } catch (erro) {
  //     toast(erroAoAtualizarDocumentos, toastOptions)
  //   }
  // }

  const acaoSucesso = async (curso: CursoCertificacaoPayload) => {
    try {
      definirCarregando(true)

      // const { edicoes, criacoes, contador } = selecaoDeDocumentosParaEnvio(
      //   documentos
      // )
      let modulosCertificacao: ModuloCursoCertificacao[] = []
      let disciplinasCertificacao: DisciplinaCursoCertificacao[] = []

      if (curso.divisao === DivisaoCursoCertificacao.Modulo) {
        modulosCertificacao = modulosCurso.map((modulo, indexModulo) => ({
          ...modulo,
          ordem: indexModulo + 1,
          disciplinasMCertificacao:
            modulo.disciplinasMCertificacao?.map(
              (disciplina, indexDisciplina) => ({
                ...disciplina,
                ordem: indexDisciplina + 1,
                deletado:
                  disciplina.deletado === undefined
                    ? false
                    : disciplina.deletado
              })
            ) ?? []
        }))
      } else {
        disciplinasCertificacao = disciplinasCurso.map((disciplina, index) => ({
          ...disciplina,
          ordem: index + 1,
          deletado:
            disciplina.deletado === undefined ? false : disciplina.deletado
        }))
      }

      const cursoPayload: CursoCertificacaoPayload = {
        ...curso,
        modulosCertificacao,
        disciplinasCertificacao
      }

      if (modo === ModoPaginaCadastro.Inclusao) {
        await Api.InserirCursoCertificacao(cursoPayload, usuarioId)

        // setIdCurso(response.cursoId)

        // if (contador !== 0) {
        //   uploadDeCriacao(response.cursoId, criacoes)
        // }
      } else {
        await Api.EditarCursoCertificacao(
          match.params.id,
          cursoPayload,
          usuarioId
        )

        // if (contador !== 0) {
        //   if (criacoes.length > 0) {
        //     await uploadDeCriacao(match.params.id, criacoes)
        //   }

        //   if (edicoes.length > 0) {
        //     await uploadDeEdicao(match.params.id, edicoes)
        //   }
        // }
        // setIdCurso(match.params.id)
      }

      await new Promise(resolve => setTimeout(resolve, 100))
      history.push(RotasCursoCertificacao.Cursos)
    } finally {
      definirCarregando(false)
    }
  }

  // useEffect(() => {
  //   if (dispararUpload && idCurso) {
  //     documentosRef.current?.enviarDocumentos()
  //     setDispararUpload(false)
  //   }
  // }, [dispararUpload, idCurso])

  const modalidadeAlterada = (opcao: SelectOpcao) => {
    definirModalidade(opcao?.id)
  }

  const divisaoAlterada = (opcao: SelectOpcao) => {
    definirDivisao(opcao?.id)
  }

  useEffect(() => {
    if (modo === ModoPaginaCadastro.Edicao) {
      carregarCurso()
    }
  }, [modalidadeCurso])

  const adicionarModulo = (modulo: ModuloCursoCertificacao) => {
    const novosModulos = [...modulosCurso, { ...modulo, disciplinas: [] }]
    definirModulosCurso(novosModulos)
  }

  const editarModulo = (moduloEditado: any) => {
    const novosModulos = modulosCurso.map((modulo, idx) => {
      if (idx === indexModulo) {
        return {
          ...modulo,
          nome: moduloEditado.nome
        }
      }
      return modulo
    })

    definirModulosCurso(novosModulos)
  }

  const adicionarDisciplina = (disciplina: DisciplinaCursoCertificacao) => {
    const novasDisciplinas = [...disciplinasCurso, { ...disciplina }]
    definirDisciplinasCurso(novasDisciplinas)
  }

  const excluirDisciplina = (indexDisciplina: number) => {
    const disciplinasAtualizadas = disciplinasCurso.map(
      (p: DisciplinaCursoCertificacao, idx: number) => {
        if (idx === indexDisciplina) {
          p.deletado = true
        }
        return p
      }
    )

    definirDisciplinasCurso(disciplinasAtualizadas)
  }

  const vinculaDisciplina = (disciplina: DisciplinaCursoCertificacao) => {
    if (indexModulo < 0 || indexModulo >= modulosCurso.length) {
      return
    }

    const modulosAtualizados = [...modulosCurso]
    const moduloAtual = modulosAtualizados[indexModulo]
    const disciplinas = moduloAtual.disciplinasMCertificacao || []

    const novasDisciplinas = [
      ...disciplinas,
      {
        id: disciplina.id,
        nome: disciplina.nome,
        cargaHoraria: disciplina.cargaHoraria,
        deletado: false
      }
    ]

    modulosAtualizados[indexModulo] = {
      ...moduloAtual,
      disciplinasMCertificacao: novasDisciplinas
    }

    definirModulosCurso(modulosAtualizados)
  }

  const desvincularDisciplina = (
    indexModulo: number,
    indexDisciplina: number
  ) => {
    const modulosAtualizados =
      modulosCurso.map((item, index) => {
        if (index === indexModulo) {
          item = {
            ...item,
            disciplinasMCertificacao: [
              ...item.disciplinasMCertificacao.map(
                (p: DisciplinaCertificacaoVinculada, idx: number) => {
                  if (idx === indexDisciplina) {
                    p.deletado = true
                  }
                  return p
                }
              )
            ]
          }
        }
        return item
      }) ?? []
    definirModulosCurso(modulosAtualizados)
  }

  const isParceiro = visao === Visao.ParceiroCertificacao

  return (
    <ContainerCertificacao>
      {pronto ? (
        <Container>
          <ContainerMain>
            <ContainerLink>
              <Link
                texto="Voltar"
                href={RotasCursoCertificacao.Cursos}
                icone={IconeBack}
              />
            </ContainerLink>
            <Cabecalho>
              <Breadcrumb
                titulo={titulo}
                atalhos={[
                  {
                    texto: 'Acadêmico',
                    acao: () => history.goBack()
                  },
                  {
                    texto: 'Cursos',
                    acao: () => history.goBack()
                  },
                  {
                    texto: titulo
                  }
                ]}
              />
            </Cabecalho>
            <Conteudo>
              <FormContainer>
                <FormUnform
                  key={curso?.id ?? curso?.nome}
                  schema={createSchema}
                  dadosIniciais={curso}
                  acaoSucesso={acaoSucesso}
                  acaoFalha={focarNoPrimeiroErro}
                >
                  <SecaoPrimaria id={Navegacoes.DadosCurso}>
                    <SubTitulo texto="Dados do Curso" />
                    <ContainerDados style={{ marginBottom: '10px' }}>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="nome"
                          label="Nome do Curso"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_modalidadade"
                          name="modalidade"
                          label="Modalidade do Curso"
                          disabled={!isParceiro}
                          obrigatorio
                          valorAlterado={modalidadeAlterada}
                          margemInferior={false}
                          opcoes={[
                            {
                              id:
                                ModalidadeCursoCertificacao[
                                  ModalidadeCursoCertificacao.Presencial
                                ],
                              texto:
                                ModalidadeCursoCertificacao[
                                  ModalidadeCursoCertificacao.Presencial
                                ]
                            },
                            {
                              id:
                                ModalidadeCursoCertificacao[
                                  ModalidadeCursoCertificacao.Online
                                ],
                              texto:
                                ModalidadeCursoCertificacao[
                                  ModalidadeCursoCertificacao.Online
                                ]
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    {/* <ContainerDados style={{ marginBottom: '30px' }}> */}
                    {/* <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_divisao"
                          name="divisao"
                          label="Divisão do Curso"
                          disabled={
                            modo === ModoPaginaCadastro.Edicao || !isParceiro
                          }
                          obrigatorio
                          valorAlterado={divisaoAlterada}
                          margemInferior={false}
                          opcoes={[
                            {
                              id:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Modulo
                                ],
                              texto:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Modulo
                                ]
                            },
                            {
                              id:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Disciplina
                                ],
                              texto:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Disciplina
                                ]
                            }
                          ]}
                        />
                      </ContainerDadosMedio> */}
                    {/* </ContainerDados> */}
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <NumeroInputUnform
                          name="cargaHoraria"
                          label="Carga Horária Obrigatória (em horas)"
                          maxLength={9}
                          obrigatorio
                          isDecimal={true}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <NumeroInputUnform
                          id="duracao"
                          name="duracao"
                          label="Duração do Curso (em meses)"
                          maxLength={4}
                          obrigatorio
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_area"
                          name="area"
                          label="Área do Curso"
                          disabled={!isParceiro}
                          obrigatorio
                          // valorAlterado={modalidadeAlterada}
                          margemInferior={false}
                          opcoes={OPCOES_AREA}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="nomeCoordenador"
                          label="Nome do Coordenador"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="cpfCoordenador"
                          label="CPF do Coordenador"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_titulacao_Coordenador"
                          name="titulacaoCoordenador"
                          label="Titulação do Coordenador"
                          disabled={!isParceiro}
                          obrigatorio
                          // valorAlterado={modalidadeAlterada}
                          margemInferior={false}
                          opcoes={OPCOES_TITULACAO_COORDENADOR}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosGrande>
                        <InputUnform
                          name="linkEmec"
                          label="Link Emec"
                          maxLength={200}
                          disabled={isParceiro}
                        />
                      </ContainerDadosGrande>
                    </ContainerDados>
                    {/* <ContainerDados>
                      <ContainerDadosGrande>
                        <ErroLayoutContainer.Provider>
                          <DocumentosCursoCertificacao
                            ref={documentosRef}
                            cursoCertificacaoId={idCurso}
                            documentos={documentos}
                            atualizar={atualizar}
                            reiniciar={reiniciar}
                          />
                        </ErroLayoutContainer.Provider>
                      </ContainerDadosGrande>
                    </ContainerDados> */}
                  </SecaoPrimaria>
                  {/* <ListaModuloDisciplina
                    modulos={modulosCurso}
                    disciplinas={disciplinasCurso}
                    divisao={divisaoCurso}
                    modalIncluirModuloRef={modalIncluirModuloRef}
                    modalIncluirDisciplinaRef={modalIncluirDisciplinaRef}
                    modalExcluirDisciplinaRef={modalExcluirDisciplinaref}
                    modalEditarModuloRef={modalEditarModuloRef}
                    modalDisciplinaModuloRef={modalDisciplinaModuloRef}
                    modalDesvincularDisciplinaref={
                      modalDesvincularDisciplinaref
                    }
                    defineIndexModulo={defineIndexModulo}
                  /> */}
                  <Spacer padding="10px 0px" />
                  <ContainerAcoes>
                    <Botao
                      texto={'Cancelar'}
                      tema="Secundario"
                      type="button"
                      disabled={carregando}
                      onClick={() =>
                        isParceiro
                          ? modalRef.current?.abrir()
                          : history.push(RotasCursoCertificacao.Cursos)
                      }
                    />
                    <Botao
                      type="submit"
                      texto="Salvar"
                      carregando={carregando}
                    />
                  </ContainerAcoes>
                </FormUnform>
              </FormContainer>
            </Conteudo>
          </ContainerMain>
          <Modal
            ref={modalRef}
            backdrop
            id="modal-confirmacao-cancelamento"
            icone={<></>}
            titulo={'Deseja cancelar?'}
            acaoPrimaria={{
              titulo: 'Sim',
              tipo: 'button',
              acao: () => history.goBack()
            }}
            acaoSecundario={{
              titulo: 'Não',
              tipo: 'button',
              acao: () => modalRef.current?.fechar()
            }}
          >
            <p>Selecione uma opção</p>
          </Modal>
          <ModalIncluirModulo
            id="modal-incluir-modulo"
            backdrop
            ref={modalIncluirModuloRef}
            acaoPrimaria={adicionarModulo}
          />
          <ModalIncluirDisciplina
            id="modal-incluir-modulo"
            backdrop
            ref={modalIncluirDisciplinaRef}
            acaoPrimaria={adicionarDisciplina}
          />
          <ModalExcluirDisciplina
            ref={modalExcluirDisciplinaref}
            backdrop={true}
            acaoPrimaria={({ indexDisciplina }) =>
              excluirDisciplina(indexDisciplina)
            }
          />
          <ModalEditarModulo
            id="modal-editar-modulo"
            backdrop
            ref={modalEditarModuloRef}
            acaoPrimaria={editarModulo}
          />
          <ModalVincularDisciplinaModulo
            id="modal-vincular-curso"
            ref={modalDisciplinaModuloRef}
            acaoPrimaria={dados => {
              vinculaDisciplina(dados)
              modalDisciplinaModuloRef?.current?.fechar()
            }}
            backdrop
            titulo="Vincular Disciplina"
          />
          <DesvincularDisciplinaModulo
            ref={modalDesvincularDisciplinaref}
            backdrop={true}
            acaoPrimaria={({ indexModulo, indexDisciplina }) =>
              desvincularDisciplina(indexModulo, indexDisciplina)
            }
          />
        </Container>
      ) : (
        <></>
      )}
    </ContainerCertificacao>
  )
}

export default withRouter(PaginaCursos)
